import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import About from "./pages/About";
import Dashboard from "./pages/Dashboard";
import Churn from "./pages/Churn";
import Ltv from "./pages/Ltv";
import DataQuality from "./pages/DataQuality";
export default function App() {
    return (_jsx(Layout, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Dashboard, {}) }), _jsx(Route, { path: "/about", element: _jsx(About, {}) }), _jsx(Route, { path: "/churn", element: _jsx(Churn, {}) }), _jsx(Route, { path: "/ltv", element: _jsx(Ltv, {}) }), _jsx(Route, { path: "/data-quality", element: _jsx(DataQuality, {}) })] }) }));
}
